import { gql } from '@apollo/client';

export const UPDATE_NOISE_MONITOR = gql`
    mutation UpdateNoiseMonitor($id: Guid!, $input: UpdateNoiseMonitor!) {
        facility {
            process {
                updateNoiseMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
